import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import TileInterface from "../../dtos/local/Tile.interface";

@Component({
  selector: 'app-system-avatars-page',
  templateUrl: './system-avatars-page.component.html',
  styleUrls: ['./system-avatars-page.component.scss']
})
export class SystemAvatarsPageComponent {

  constructor(
    public route: ActivatedRoute,
    public router: Router
  ) {
  }

  async create() {
    await this.router.navigate(['new'], {relativeTo: this.route});
  }

  async edit(tile: TileInterface) {
    // or show create modal?
    await this.router.navigate([tile.tileId], {relativeTo: this.route});
  }

}
